import { updateField } from 'vuex-map-fields';
import StatusTypes from '../../../helpers/enums/statusTypes.enum';

export default {
  START_LOADING_INSTANT_REPLIES(state) {
    state.loadingInstantReplies = true;
  },
  SET_INSTANT_REPLIES_LIST(state, payload) {
    state.instantReplyList = payload;
    state.loadingInstantReplies = false;
  },
  SET_INSTANT_REPLY(state, payload) {
    state.instantReply = payload;
  },
  INSTANT_REPLY_SAVED(state, payload) {
    state.instantReplySaved = payload;
  },
  INSTANT_REPLY_DELETED(state, payload) {
    state.instantReplyDeleted = payload;
  },
  INSTANT_REPLY_MESSAGE_DELETED(state, payload) {
    state.instantReplyMessageDeleted = payload;
  },
  SET_KEYWORD_ANALYTICS(state, payload) {
    state.keywordAnalytics = payload;
  },

  START_LOADING_RULES(state) {
    state.automationRulesLoaded = false;
  },
  SET_RULE_LIST(state, payload) {
    state.automationRules = payload;
    state.automationRulesLoaded = true;
  },
  AUTOMATION_RULE_SAVED(state, payload) {
    state.automationRuleSaved = payload;
  },
  AUTOMATION_RULE_DELETED(state, payload) {
    state.automationRuleDeleted = payload;
  },

  SET_AUTOMATION_SETTINGS(state, payload) {
    state.automationSettings = payload;
  },
  AUTOMATION_SETTINGS_SAVED(state, payload) {
    state.automationSettingsSaved = payload;
  },
  UNSUBSCRIBE_MESSAGE_SAVED(state, payload) {
    state.unsubscribeMessageSaved = payload;
  },
  UPDATE_UNSUBSCRIBED_MESSAGE(state, newMessage) {
    state.automationSettings.unsubscribe_message = newMessage;
  },
  FILE_UPLOADED(state, payload) {
    state.uploadedFile = payload;
  },
  API_ERROR(state, payload) {
    if (payload) {
      state.apiError = payload;
    }
  },
  FILE_UPLOAD_ERROR(state, payload) {
    state.fileUploadError = payload;
  },
  UPDATE_IN_PROGRESS(state, payload) {
    if (!state.actionInProgress[payload.assistantId]) {
      state.actionInProgress[payload.assistantId] = {};
    }
    if (payload.status === StatusTypes.COMPLETED) {
      delete state.actionInProgress[payload.assistantId][`${payload.action}-${payload.type}`];
    } else {
      state.actionInProgress[payload.assistantId][`${payload.action}-${payload.type}`] = payload.status;
    }
    if (Object.keys(state.actionInProgress[payload.assistantId]).length === 0) {
      delete state.actionInProgress[payload.assistantId];
    }
    state.actionInProgress = { ...state.actionInProgress };
  },
  CLEAR_BACKGROUND_ACTIONS(state) {
    state.backgroundActions = [];
  },
  ADD_BACKGROUND_ACTIONS(state, actions) {
    actions.forEach((a) => {
      // check if it already exists and ignore if it does
      const existingAction = state.backgroundActions.findIndex(
        (action) => {
          if (a.type) {
            return action.assistantId === a.assistantId && action.action === a.action && action.type === a.type;
          }
          return action.assistantId === a.assistantId && action.action === a.action;
        },
      );

      if (existingAction < 0) {
        state.backgroundActions = [...state.backgroundActions, a];
        // add action to the list of actions started by user so the toast can be shown only to the user that initiated the action
        state.backgroundActionsStartedByUser = [...state.backgroundActionsStartedByUser, { assistantId: a.assistantId, action: a.action }];
      } else {
        // Action already exists, just update it
        state.backgroundActions[existingAction] = { ...state.backgroundActions[existingAction], ...a };
        state.backgroundActions = [...state.backgroundActions];
      }
    });
  },
  REMOVE_BACKGROUND_ACTION(state, actionId) {
    state.backgroundActions = state.backgroundActions.filter(action => action.id !== actionId);
  },
  UPDATE_BACKGROUND_ACTION(state, payload) {
    setTimeout(() => {
      let index = null;
      if (payload.type) {
        index = state.backgroundActions.findIndex(action => action.assistantId === payload.assistantId && action.action === payload.action && action.type === payload.type);
      } else {
        index = state.backgroundActions.findIndex(action => action.assistantId === payload.assistantId && action.action === payload.action);
      }
      if (index >= 0) {
        state.backgroundActions[index] = { ...state.backgroundActions[index], ...payload.data, timestamp: Date.now() };
        if (payload.data.status) {
          state.backgroundActions[index].status = payload.data.status;
        }
        state.backgroundActions = [...state.backgroundActions];
      }
    });
  },
  // Remove the action from the list of actions started by user after the action is finished and toast is shown.
  REMOVE_BACKGROUND_ACTION_STARTED_BY_USER(state, payload) {
    state.backgroundActionsStartedByUser = state.backgroundActionsStartedByUser.filter(action => !(action.assistantId === payload.assistantId && action.action === payload.action));
    state.backgroundActionsStartedByUser = [...state.backgroundActionsStartedByUser];
  },
  FILE_UPLOAD_CANCELLED(state, payload) {
    state.fileUploadCancelled = payload;
  },
  SET_NEW_SCHEMA_VALUES(state, payload) {
    state.updatedAISchema = payload;
  },
  ASSISTANT_DATA_SAVED(state, payload) {
    state.assistantDataSaved = payload;
  },
  SET_SCRAPING_STATUS(state, payload) {
    state.scrapingStatus[payload.assistantId] = payload.status;
    state.scrapingStatus = { ...state.scrapingStatus };
  },
  REMOVE_ALL_COUNTERS(state) {
    state.webScrapeCounter = {};
    state.webScrapeDeleteCounter = {};
    state.fileUploadCounter = {};
    state.fileDeleteCounter = {};
  },
  UPDATE_COUNTER(state, payload) {
    state.updatedCounter = payload;

    const type = payload.url === 'specific links' ? 'specific' : 'all';
    if (!state.webScrapeCounter[payload.ai_assistant_uid]) {
      state.webScrapeCounter[payload.ai_assistant_uid] = {};
    }
    if (!state.webScrapeCounter[payload.ai_assistant_uid][type]) {
      state.webScrapeCounter[payload.ai_assistant_uid][type] = { all: 0, current: 0 };
    }
    if (payload.all) {
      state.webScrapeCounter[payload.ai_assistant_uid][type] = (({ all, current }) => ({ all, current }))(payload);
    } else {
      state.webScrapeCounter[payload.ai_assistant_uid][type].current = payload.links_count;
    }

    if (state.webScrapeCounter[payload.ai_assistant_uid][type].all) {
      state.webScrapeCounter[payload.ai_assistant_uid][type].percentage = Math.round((state.webScrapeCounter[payload.ai_assistant_uid][type].current / state.webScrapeCounter[payload.ai_assistant_uid][type].all) * 100);
    }

    state.webScrapeCounter = { ...state.webScrapeCounter };
  },
  REMOVE_COUNTER(state, payload) {
    const type = payload.url === 'specific links' ? 'specific' : 'all';
    if (state.webScrapeCounter[payload.ai_assistant_uid]) {
      delete state.webScrapeCounter[payload.ai_assistant_uid][type];
    }
    if (state.webScrapeCounter && state.webScrapeCounter[payload.ai_assistant_uid] && Object.keys(state.webScrapeCounter[payload.ai_assistant_uid]).length === 0) {
      delete state.webScrapeCounter[payload.ai_assistant_uid];
    }
    state.webScrapeCounter = { ...state.webScrapeCounter };
  },
  UPDATE_DELETE_COUNTER(state, payload) {
    state.updatedCounter = payload;
    const type = ['specific links', 'specific'].includes(payload.url) ? 'specific' : 'all';
    if (!state.webScrapeDeleteCounter[payload.ai_assistant_uid]) {
      state.webScrapeDeleteCounter[payload.ai_assistant_uid] = {};
    }
    if (!state.webScrapeDeleteCounter[payload.ai_assistant_uid][type]) {
      state.webScrapeDeleteCounter[payload.ai_assistant_uid][type] = { all: 0, current: 0 };
    }
    if (payload.all) {
      state.webScrapeDeleteCounter[payload.ai_assistant_uid][type] = (({ all, current }) => ({ all, current }))(payload);
    } else {
      state.webScrapeDeleteCounter[payload.ai_assistant_uid][type].current = payload.links_count;
    }

    if (state.webScrapeDeleteCounter[payload.ai_assistant_uid][type].all) {
      state.webScrapeDeleteCounter[payload.ai_assistant_uid][type].percentage = Math.round((state.webScrapeDeleteCounter[payload.ai_assistant_uid][type].current / state.webScrapeDeleteCounter[payload.ai_assistant_uid][type].all) * 100);
    }

    state.webScrapeDeleteCounter = { ...state.webScrapeDeleteCounter };
  },
  REMOVE_DELETE_COUNTER(state, payload) {
    const type = payload.url === 'specific links' ? 'specific' : 'all';
    delete state.webScrapeDeleteCounter[payload.ai_assistant_uid][type];
    if (Object.keys(state.webScrapeDeleteCounter[payload.ai_assistant_uid]).length === 0) {
      delete state.webScrapeDeleteCounter[payload.ai_assistant_uid];
    }
    state.webScrapeDeleteCounter = { ...state.webScrapeDeleteCounter };
  },
  UPDATE_FILE_CHANGE_COUNTER(state, payload) {
    // if (payload.filesAdded) {
    //   state.fileChangesTracker.filesAdded += payload.filesAdded;
    // }
    // if (payload.filesRemoved) {
    //   state.fileChangesTracker.filesRemoved += payload.filesRemoved;
    // }
    // state.fileChangesTracker = { ...state.fileChangesTracker };
  },
  CLEAR_FILE_CHANGE_COUNTER(state) {
    state.fileChangesTracker = {
      filesAdded: 0,
      filesRemoved: 0,
    };
  },
  RESET_TEMP_FILE_COUNTER(state, aiAssistantUid) {
    if (state.tempFileCounter[aiAssistantUid]) {
      delete state.tempFileCounter[aiAssistantUid];
      state.tempFileCounter = { ...state.tempFileCounter };
    }
  },
  UPDATE_FILE_UPLOAD_COUNTER(state, payload) {
    if (!state.fileUploadCounter[payload.ai_assistant_uid]) {
      state.fileUploadCounter[payload.ai_assistant_uid] = {};
    }
    if (!state.tempFileCounter[payload.ai_assistant_uid]) {
      state.tempFileCounter[payload.ai_assistant_uid] = {
        uploaded: 0,
        deleted: 0,
      };
    }
    state.fileUploadCounter[payload.ai_assistant_uid] = { ...state.fileUploadCounter[payload.ai_assistant_uid], ...payload };
    if (payload.all) {
      state.fileUploadCounter[payload.ai_assistant_uid].percentage = Math.round((state.fileUploadCounter[payload.ai_assistant_uid].uploaded / state.fileUploadCounter[payload.ai_assistant_uid].all) * 100);
    } else if (payload.finished) {
      state.fileUploadCounter[payload.ai_assistant_uid].percentage = 100;
    }
    state.fileUploadCounter = { ...state.fileUploadCounter };

    if (payload.uploaded) {
      state.tempFileCounter[payload.ai_assistant_uid].uploaded = payload.uploaded;
      state.tempFileCounter = { ...state.tempFileCounter };
    }

    if (state.fileUploadCounter[payload.ai_assistant_uid].percentage === 100) {
      // this status is set only a precaution so if it maybe starts running again in a few seconds it does not get deleted
      state.fileUploadCounter[payload.ai_assistant_uid].status = StatusTypes.COMPLETED;
      // state.fileChangesTracker.filesAdded += state.tempFileCounter.uploaded;
      // state.tempFileCounter[payload.ai_assistant_uid].uploaded = 0;
      setTimeout(() => {
        if (state.fileUploadCounter[payload.ai_assistant_uid] && state.fileUploadCounter[payload.ai_assistant_uid].status === StatusTypes.COMPLETED) {
          delete state.fileUploadCounter[payload.ai_assistant_uid];
          state.fileUploadCounter = { ...state.fileUploadCounter };
        }
      }, 0);
    }
  },
  UPDATE_FILE_DELETE_COUNTER(state, payload) {
    if (!state.fileDeleteCounter[payload.ai_assistant_uid]) {
      state.fileDeleteCounter[payload.ai_assistant_uid] = {};
    }
    if (!state.tempFileCounter[payload.ai_assistant_uid]) {
      state.tempFileCounter[payload.ai_assistant_uid] = {
        uploaded: 0,
        deleted: 0,
      };
    }
    state.fileDeleteCounter[payload.ai_assistant_uid] = { ...state.fileDeleteCounter[payload.ai_assistant_uid], ...payload };
    if (payload.all) {
      state.fileDeleteCounter[payload.ai_assistant_uid].percentage = Math.round((state.fileDeleteCounter[payload.ai_assistant_uid].deleted / state.fileDeleteCounter[payload.ai_assistant_uid].all) * 100);
    } else if (payload.finished) {
      state.fileDeleteCounter[payload.ai_assistant_uid].percentage = 100;
    }
    state.fileDeleteCounter = { ...state.fileDeleteCounter };

    if (payload.deleted) {
      state.tempFileCounter[payload.ai_assistant_uid].deleted = payload.deleted;
      state.tempFileCounter = { ...state.tempFileCounter };
    }

    if (state.fileDeleteCounter[payload.ai_assistant_uid].percentage === 100) {
      // this status is set only a precaution so if it maybe starts running again in a few seconds it does not get deleted
      state.fileDeleteCounter[payload.ai_assistant_uid].status = StatusTypes.COMPLETED;
      // state.fileChangesTracker.filesRemoved += state.tempFileCounter.deleted;
      // state.tempFileCounter[payload.ai_assistant_uid].deleted = 0;
      setTimeout(() => {
        if (state.fileDeleteCounter[payload.ai_assistant_uid] && state.fileDeleteCounter[payload.ai_assistant_uid].status === StatusTypes.COMPLETED) {
          delete state.fileDeleteCounter[payload.ai_assistant_uid];
          state.fileDeleteCounter = { ...state.fileDeleteCounter };
        }
      }, 0);
    }
  },
  updateField,
};
